import React, { useState, useEffect } from "react";

import { Box, Button } from "@mui/material";
import FileUpload from "../FileUploadComponent/FileUpload";
import { TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { lengthAndValidCharactersInStringCheck } from "../../../utils/commonFunctions";
import { useAppDispatch } from "../../../services/StoreHooks";
import useTranslatewrapper from "../../../components/useTranslateWrapper";

function GetAllFiles({
  createFileUploadFields,
  handleFileDelete,
  getFileData,
  setRemovedNames,
  setShowButton,
  testDone,
  isMonitor,
  sampleId
}) {
  const {translate} = useTranslatewrapper();
  const [categoryDocs, setCategoryDocs] = React.useState(
    createFileUploadFields || []
  );

  const dispatch = useAppDispatch();
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handleChangeInput = (event, index) => {

    if(event.target.value){
      let arrErr = [];
      let validationResult = lengthAndValidCharactersInStringCheck(event.target.value);
      if (!validationResult['status']) {
        arrErr.push("Filename" + ": " + validationResult['message'])
        dispatchNotification("error", arrErr);
        return;
      }
    }

    setShowButton(true);

    let data = [...categoryDocs];
    data[index]["name"] = event.target.value;
    setCategoryDocs(() => data);
  };

  const addRow = () => {
    setShowButton(true);

    setCategoryDocs([
      ...categoryDocs,
      {
        name: "",
        paths: [],
      },
    ]);
  };

  const removeRows = (index) => {
    if (Array.isArray(categoryDocs) && index > -1) {
      setShowButton(true);

      let data = [...categoryDocs];
      const currentRow = { ...data[index] };
      setRemovedNames((name) => [...name, currentRow.name]);
      data.splice(index, 1);
      setCategoryDocs(data);
    }
  };

  const fileNamesToTranslate = ['lab report']

  return (
    <div>
      <Box sx={{ display: "flex", flexWrap: "wrap", width: "77.5vw" }}>
        {categoryDocs?.map((obj, idx) => {
          return (
            <Box
              sx={{
                fontSize: "13px",
                flexBasis: " calc(33% - 20px)",
              }}
              key={idx}
            >
              {obj?.id ? (
                <p style={{ marginBottom: "0px" }}>
                  {fileNamesToTranslate.includes(obj?.name.toLowerCase()) ? translate(obj?.name.toLowerCase()): obj?.name}{" "}
                  {obj?.isMandatory == true
                    ? "*"
                    : ""}
                </p>
              ) : (
                <>
                  <TextField
                    disabled={testDone || isMonitor}
                    sx={{ width: "25ch", marginBottom: "1rem" }}
                    name="name"
                    id="outlined-basic"
                    value={obj.name}
                    variant="standard"
                    label={translate('fileName')}
                    required
                    onChange={(e) => handleChangeInput(e, idx)}
                  />
                  <Button
                    disabled={testDone || isMonitor}
                  
                  >
                    <CloseIcon
                    sx={{ fontSize: "20px", marginTop: "1.5rem" }}
                    onClick={() => removeRows(idx)}
                  ></CloseIcon>

                  </Button>
                  
                </>
              )}
              {(obj?.id || obj?.name) && (
                <FileUpload
                sampleId={sampleId}
                  callType={obj.id ? "api" : "custom"}
                  info={obj}
                  paths={obj.paths}
                  getFileData={getFileData}
                  handleFileDelete={handleFileDelete}
                  setShowButton={setShowButton}
                  testDone={testDone}
                  isMonitor={isMonitor}
                />
              )}
            </Box>
          );
        })}
      </Box>

      <Button
        disabled={testDone || isMonitor}
        variant="outlined"
        sx={{ marginTop: "10px" }}
        onClick={() => addRow()}
      >
        {translate('other')}
      </Button>
    </div>
  );
}

export default GetAllFiles;
